/* eslint-disable no-restricted-globals */
/* eslint-disable indent */
import Config from '~/config';
import { groupMessages, messageTimeThreshold } from '~/modules/chatEntities';
import { addMessage } from '~/modules/chatMessages';

// name => id map
const rooms = {};
const privateRooms = {};
const history = {};

let blockList = {};

const roomNamePM = (roomId) => {
  const roomPrivate = Object.entries(privateRooms).find(room => room[1] === roomId);
  return roomPrivate ? roomPrivate[0].slice(1) : null;
};

const messageBreaks = (message, roomId) => {
  const prevMessage = history[roomId].lastMessage;

  if (!prevMessage) return true;

  const prevMessageBreaks = prevMessage && (prevMessage.serverMessage || !prevMessage.created_at);
  if (prevMessageBreaks) return true;

  const serverMessage = message.serverMessage || !message.created_at;

  if (serverMessage) return true;

  const sameUser = message.user.uid === prevMessage.user.uid;

  if (!sameUser) return true;

  const recentEnough = messageTimeThreshold(prevMessage, message);

  if (!recentEnough) return true;

  if (message.isPrivate || prevMessage.isPrivate) return true;

  return false;
};

const leaveRoom = (roomId) => {
  if (history[roomId]) {
    // @ts-ignore
    const roomName = Object.entries(rooms).find(room => room[1] === roomId)[0];
    delete history[roomId];
    delete rooms[roomName];
    delete privateRooms[roomName];
  }
};

const joinRoom = (room) => {
  const previouslyJoined = room.name in rooms;

  if (previouslyJoined && room.isPrivate) return;

  rooms[room.name] = room.id;

  if (!history[room.id]) {
    history[room.id] = {
      messages: groupMessages(room.messages),
    };

    const { messages } = history[room.id];

    if (messages.length) {
      history[room.id].lastMessage = history[room.id].messages[history[room.id].messages.length - 1];

      if (Array.isArray(history[room.id].lastMessage)) {
        history[room.id].lastMessage = history[room.id].lastMessage[history[room.id].lastMessage.length - 1];
      }
    }
  } else {
    history[room.id].lastMessage = null;
  }

  if (room.isPrivate) {
    privateRooms[room.name] = room.id;
    const message = room.messages[room.messages.length - 1];
    self.postMessage({
      private: true,
      type: addMessage.toString(),
      payload: {
        message: {
          ...message,
          roomName: roomNamePM(room.id),
        },
        roomId: room.id,
        breaks: true,
      },
    });
  }

  if (room.isStreamRoom && !previouslyJoined) {
    fetch(`${Config.api}/streams/${room.name}`)
      .then(res => res.json())
      .then((response) => {
        const streams = response.data.filter(stream => stream.username !== room.name);

        if (streams.length <= 1) return;

        const message = {
          id: (Math.random() * 1000000).toString(16),
          roomId: room.id,
          serverMessage: true,
          alert: 'multi',
          created_at: new Date(),
          component: {
            id: 'ChatMulti_Info',
            defaultMessage: '{host} is hosting a multistream with {members}',
            values: {
              // @ts-ignore
              host: room.name,
              // @ts-ignore
              members: streams.map(stream => stream.username).join(', '),
            },
          },
        };

        history[room.id].lastMessage = message;

        // @ts-ignore
        self.postMessage({
          type: addMessage.toString(),
          payload: {
            roomId: room.id,
            breaks: true,
            message,
          },
        });
      });
  }
};

const userOptions = {};

const handleMessage = ({ options, roomId, message, roomName }) => {
  const isMeBloked = message.serverMessage && message.text && Object.keys(blockList).some(username => message.text.startsWith(`<i>${username} `));
  const isBlocked = message.user && message.user.username in blockList;

  if (!roomId && roomName) {
    if (roomName in rooms) {
      roomId = rooms[roomName];
    } else {
      return;
    }
  }

  if (isBlocked || isMeBloked || !history[roomId]) return;

  const breaks = messageBreaks(message, roomId);

  if (breaks) {
    const group = [message];
    // @ts-ignore
    group.id = message.id;
    history[roomId].messages.push(group);
  } else {
    history[roomId].messages[history[roomId].messages.length - 1].push(message);
  }

  history[roomId].lastMessage = message;

  if (message.component && options[message.component.id] === false) return;

  if (Object.values(privateRooms).some(id => id === roomId)) {
    self.postMessage({
      private: true,
      type: addMessage.toString(),
      payload: {
        message: {
          ...message,
          roomName: roomNamePM(roomId),
        },
        roomId,
        breaks,
      },
    });
  }

  // @ts-ignore
  self.postMessage({
    type: addMessage.toString(),
    payload: {
      message,
      roomId,
      breaks,
    },
  });
};

// eslint-disable-next-line no-restricted-globals
self.onmessage = (ev) => {
  switch (ev.data.type) {
    case 'JOIN_ROOM':
      joinRoom(ev.data.room);
      break;

    case 'SET_BLOCKLIST':
      blockList = {};
      ev.data.payload.forEach((user) => {
        if (user) {
          blockList[user.username] = user.username;
        }
      });
      break;

    case 'ADD_MESSAGE':
      handleMessage(ev.data);
      break;

    case 'LEAVE_ROOM':
      leaveRoom(ev.data.roomId);
      break;

    default:
      break;
 }
};
